"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

require("./ProgressBar.css");

function ProgressBar(props) {
  var size = props.size,
      className = props.className,
      percentCompleted = props.percentCompleted,
      prefix = props.prefix,
      suffix = props.suffix,
      extraProps = (0, _objectWithoutProperties2["default"])(props, ["size", "className", "percentCompleted", "prefix", "suffix"]);
  var classNames = (0, _classnames["default"])(['stx-progress-bar', {
    'stx-progress-bar--small': size === 'small'
  }, {
    'stx-progress-bar--large': size === 'large'
  }, className]);
  var progressStyle = {
    width: "".concat(percentCompleted, "%")
  };
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: classNames
  }, extraProps, {
    role: "progressbar",
    "aria-valuenow": percentCompleted,
    "aria-valuemin": "0",
    "aria-valuemax": "100"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "stx-progress-bar__prefix"
  }, prefix), /*#__PURE__*/_react["default"].createElement("div", {
    className: "stx-progress-bar__container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "stx-progress-bar__fill",
    style: progressStyle
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "stx-progress-bar__suffix"
  }, suffix));
}

;
ProgressBar.defaultProps = {
  percentCompleted: 0
};
ProgressBar.propTypes = {
  className: _propTypes["default"].string,
  percentCompleted: _propTypes["default"].number,
  size: _propTypes["default"].oneOf(['small', 'large', '']),
  prefix: _propTypes["default"].node,
  suffix: _propTypes["default"].node
};
var _default = ProgressBar;
exports["default"] = _default;